export const SRP_CONTENT_PANEL_MAX_WIDTH = '800px';
